import { Uuid } from '../dto/common.js';
/**
 * The move token's grammar (1.0b deliverable 16b): `mt1.<sourceDocId>.<sourceBodyVersion>`, the
 * literal `mt1`, a dot, the source document's id as a lower-case canonical UUID, a dot, and the
 * source's body version in decimal (a positive safe integer, no leading zero).
 *
 * One function builds every token, so 1.X's client and 1.A's server agree. The parser stays with
 * the server: `parseMoveToken` is 1.A's, which proves that it inverts this function; contracts
 * exports none. `BlockMoveV1.moveToken` keeps its schema (any string of 1 to 1,000 characters),
 * so a token of another form (1.H's `local:` tokens) still parses and 1.A refuses it with a
 * warning. Pure and isomorphic.
 *
 * Throws a `RangeError` for an id that `Uuid` refuses or a version that is not a positive safe
 * integer.
 */
export function formatMoveToken(sourceDocId, sourceBodyVersion) {
    if (typeof sourceDocId !== 'string' || !Uuid.safeParse(sourceDocId).success) {
        throw new RangeError(`a move token needs a UUID, got ${JSON.stringify(sourceDocId)}`);
    }
    if (typeof sourceBodyVersion !== 'number' ||
        !Number.isSafeInteger(sourceBodyVersion) ||
        sourceBodyVersion < 1) {
        throw new RangeError(`a move token needs a positive safe integer body version, got ${String(sourceBodyVersion)}`);
    }
    return `mt1.${sourceDocId.toLowerCase()}.${String(sourceBodyVersion)}`;
}
//# sourceMappingURL=move-token.js.map